import { formatTime } from '@/utils/utils'

/**
 * 将日期过滤为 yyyy-MM-dd hh:mm:ss 格式
 * @param {*} time
 */
export function fullDate (time) {
  if (!time) { return '-' }

  return formatTime(time, 'yyyy-MM-dd hh:mm:ss')
}

/**
 * 将日期过滤为 yyyy-MM-dd 格式
 * @param {*} time
 */
export function dayDate (time) {
  if (!time) { return '-' }

  return formatTime(time, 'yyyy-MM-dd')
}

export function tenThousand (number) {
  if (typeof (number) !== 'number') { return 0 }

  return number / 10000
}

export function ratio (value) {
  if (!value) return '-'
  let _value = Number(value)
  if (_value > 0) {
    _value = '↑' + Math.abs(_value) + '%'
  } else if (_value < 0) {
    _value = '↓' + Math.abs(_value) + '%'
  }
  return _value
}

// 格式化金额
export function money (num) {
  if (isNaN(Number(num))) return ''
  num = parseFloat(num)
  num = num.toFixed(1)
  let str = num.toString().split('.')[1]
  let arr = Math.floor(num).toString().split('').reverse()
  let res = []
  for (let i = 0; i < arr.length; i++) {
    if (i % 3 === 0 && i !== 0) {
      res.push(',')
    }
    res.push(arr[i])
  }
  res = res.reverse().join('')
  if (res == '0') {
    return res
  }
  return res + '.' + str
}
export function money2 (num) {
  if (isNaN(Number(num))) return ''
  num = parseFloat(num)
  num = num.toFixed(2)
  let str = num.toString().split('.')[1]
  let arr = Math.floor(num).toString().split('').reverse()
  let res = []
  for (let i = 0; i < arr.length; i++) {
    if (i % 3 === 0 && i !== 0) {
      res.push(',')
    }
    res.push(arr[i])
  }
  res = res.reverse().join('')
  return res + '.' + str
}

// 从参数中获取国旗图标
export function flag (param) {
  var icon = ''
  if (!param || !Array.isArray(param)) {
    return ''
  }
  param.forEach((item) => {
    if (item.key === '国家') {
      icon = (item && item.icon) || ''
    }
  })
  return icon
}
